import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { ToastContainer, toast, Slide } from 'react-toastify';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest } from '../../requestUtils';
import { formatDateForApi } from '../../dateUtils';
import './AdminCreateInvoiceModal.scss';
var AdminCreateInvoiceModal = /*#__PURE__*/function (_Component) {
  function AdminCreateInvoiceModal(props) {
    var _this;
    _classCallCheck(this, AdminCreateInvoiceModal);
    _this = _callSuper(this, AdminCreateInvoiceModal, [props]);
    _this.state = {
      startDate: new Date()
    };
    _this.handleCreateInvoice = _this.handleCreateInvoice.bind(_this);
    return _this;
  }
  _inherits(AdminCreateInvoiceModal, _Component);
  return _createClass(AdminCreateInvoiceModal, [{
    key: "handleCreateInvoice",
    value: function handleCreateInvoice() {
      var _this$props = this.props,
        projectId = _this$props.projectId,
        createInvoiceUrl = _this$props.createInvoiceUrl,
        csrfToken = _this$props.csrfToken;
      var startDate = this.state.startDate;

      // startDate is a raw Date (react-datepicker) — format at this API boundary so
      // JSON.stringify never converts it to UTC and picks the wrong month around local midnight.
      var params = {
        invoice: {
          project_id: projectId,
          start_date: formatDateForApi(startDate)
        }
      };
      postRequest(createInvoiceUrl, params, csrfToken).then(function () {
        return window.location.reload();
      }, function (error) {
        return toast.error(error.message);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        triggerText = _this$props2.triggerText,
        triggerType = _this$props2.triggerType;
      var startDate = this.state.startDate;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        buttonStyles: "primary",
        submitButtonText: "Create Timesheet",
        cancelButtonText: "Cancel",
        handleSubmit: this.handleCreateInvoice,
        triggerType: triggerType,
        idKey: "admin-create-invoice",
        modalSize: "md"
      }, /*#__PURE__*/React.createElement(ToastContainer, {
        position: "top-center",
        transition: Slide,
        hideProgressBar: true,
        autoClose: 4000,
        closeOnClick: true,
        draggable: false,
        pauseOnHover: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "admin-create-invoice-modal-content mx-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "admin-create-invoice-text mb-5"
      }, "Creating a timesheet for a month that already has an existing timesheet is not allowed, but otherwise there are no limitations on what month you can select.", /*#__PURE__*/React.createElement("p", null), "Select the month for which you want to create a timesheet in the box below."), /*#__PURE__*/React.createElement("div", {
        className: "admin-create-invoice-datepicker"
      }, /*#__PURE__*/React.createElement(DatePicker, {
        selected: startDate,
        onChange: function onChange(newDate) {
          return _this2.setState({
            startDate: newDate
          });
        },
        dateFormat: "MM/yyyy",
        showMonthYearPicker: true,
        showFullMonthYearPicker: true,
        showTwoColumnMonthYearPicker: true
      }))));
    }
  }]);
}(Component);
export default AdminCreateInvoiceModal;
AdminCreateInvoiceModal.propTypes = {
  projectId: PropTypes.number.isRequired,
  createInvoiceUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  triggerText: PropTypes.string.isRequired,
  triggerType: PropTypes.string.isRequired
};